import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import {
  URL_REPORTING_EXPORTS,
  URL_REPORTING_EXPORTS_THRESHOLD,
  URL_REPORTING_EXPORT_BY_UUID,
} from "store/services/URL";

export const fetchReportExportThreshold = () =>
  apiGetRequest(URL_REPORTING_EXPORTS_THRESHOLD);

export const fetchReportExports = ({
  page = 1,
  perPage = 15,
  status,
  format,
  report_type,
  search,
  date_from,
  date_to,
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });

  if (status && status !== "all") {
    params.append("status", status);
  }
  if (format && format !== "all") {
    params.append("format", format);
  }
  if (report_type && report_type !== "all") {
    params.append("report_type", report_type);
  }
  if (search?.trim()) {
    params.append("search", search.trim());
  }
  if (date_from) {
    params.append("date_from", date_from);
  }
  if (date_to) {
    params.append("date_to", date_to);
  }

  return apiGetRequest(`${URL_REPORTING_EXPORTS}?${params.toString()}`);
};

export const fetchReportExportByUuid = (uuid) =>
  apiGetRequest(URL_REPORTING_EXPORT_BY_UUID(uuid));

export const queueReportExport = (payload) =>
  apiPostRequest(URL_REPORTING_EXPORTS, payload);
